import { Component, ViewChild } from '@angular/core';
import { Refreshable } from './types/refreshable';

@Component({
    selector: "app-root",
    template: `
        <app-header (config_changed)="refreshComponent()" (restoreClicked)="restoreDefaults()"></app-header>
        <main class="container-fluid p-1">
            <router-outlet (activate)="setRoutedComponent($event)"></router-outlet>
        </main>
        <app-footer #footer></app-footer>
    `
})
export class AppComponent {
  title = 'feeder';

  @ViewChild('footer') footer: any;

    routedComponent!: Refreshable;

    setRoutedComponent(componentRef: any) {
        this.routedComponent = componentRef;
    }

    refreshComponent() {
        this.routedComponent.refresh();
        this.footer.refresh();
    }

    restoreDefaults() {
        this.routedComponent.restoreDefaults();
    }
}
